const transformDiscountDto = _ref => {
  let {
    fraction,
    minimal_item_count
  } = _ref;
  return {
    fraction,
    minimalItemCount: minimal_item_count
  };
};

export const transformDiscountDtos = dtos => dtos.map(transformDiscountDto);
export const transformUserBundleDiscountDto = dto => ({
  id: dto.id,
  userId: dto.user_id,
  isEnabled: dto.enabled,
  minimalItemCount: dto.minimal_item_count,
  fraction: dto.fraction,
  discounts: transformDiscountDtos(dto.discounts)
});
export const transformBundleDiscountsConfigurationDto = _ref2 => {
  let {
    discounts,
    default_discounts
  } = _ref2;
  return {
    discountFractions: discounts,
    defaultDiscounts: transformDiscountDtos(default_discounts)
  };
};